<template>
  <div :class="[$style.toolbar, 'contents__title']">
    <h2 :class="$style.title" :title="title"> {{title}} </h2>
    <div style="margin-top: -5px;">
      <div v-if="!isEditMode">
        <span class="cmp-margin-right">
          <w-dashboard-theme-dropdown v-if="isGridDashboard"></w-dashboard-theme-dropdown>
          <span class="dashboard-icon-group">
            <w-map-button type="button" icon="btn-responsive" :toggle="true" :pressed="isResponsive" :tooltip="isResponsive ? '반응형 동작 중' : '반응형 미동작 중'" @onClick="onResponsiveClick" v-if="isGridDashboard" :disabled="disabled"></w-map-button>
            <w-map-button type="button" icon="btn-slideshow" tooltip="슬라이드쇼" @onClick="onSlideshowClick" :disabled="disabled" v-if="isCoordDashboard"></w-map-button>
          </span>
          <w-dashboard-download-dropdown :disabled="disabled"></w-dashboard-download-dropdown>
          <span class="dashboard-icon-group">
            <w-map-button type="button" icon="btn-full" tooltip="전체화면" @onClick="onFullScreenClick" :disabled="disabled"></w-map-button>
          </span>
        </span>
        <!-- add style 1217 -->
        <el-button style="padding-top:3px" size="medium" type="solid" @click="onDashboardEditClick" :disabled="disabled">대시보드 편집</el-button>
      </div>
      <div v-else>
        <span>
          <w-rotation-visible-select v-if="isCoordDashboard" :disabled="!isActive" style="vertical-align: middle; margin-right: 5px;"></w-rotation-visible-select>
          <w-widget-align-button v-if="isCoordDashboard" :disabled="!isActive"></w-widget-align-button>
          <w-widget-select-toggle v-if="isCoordDashboard" :disabled="!isActive"></w-widget-select-toggle>
          <span class="dashboard-icon-group">
            <w-map-button type="button" icon="btn-setting-icon" tooltip="대시보드 설정" @onClick="onDashboardSettingClick" v-if="isCoordDashboard" :disabled="disabled"></w-map-button>

          </span>
          <el-button size="medium" type="secondary" @click="onResetClick" :disabled="disabled">초기화</el-button>
          <el-button size="medium" type="primary" @click="onSaveClick" :disabled="disabled">저장</el-button>
          <el-button size="medium" type="content" @click="onCancelClick" :disabled="disabled">취소</el-button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { filter, isEmpty } from 'lodash';

import DashboardAPI from '@/api/dashboard/common';

import DashboardConst from '@/constants/dashboard';

import msgUtil from '@/utils/message';

import WMainTitle from '@/components/template/MainTitle';
import WWidgetAlignButton from '@/views/dashboard/components/WidgetAlignButton';
import WWidgetSelectToggle from '@/views/dashboard/components/WidgetSelectToggle';
import WRotationVisibleSelect from '@/views/dashboard/components/RotationVisibleSelect';
import WDashboardThemeDropdown from '@/views/dashboard/components/DashboardThemeDropdown';
import WDashboardDownloadDropdown from '@/views/dashboard/components/DashboardDownloadDropdown';
import WMapButton from '@/views/topologymap/components/MapButton';
import Base from '@/mixins/dashboard/base';

export default {
  name: 'WDashboardToolbar',
  components: {
    WMainTitle,
    WWidgetAlignButton,
    WWidgetSelectToggle,
    WRotationVisibleSelect,
    WDashboardThemeDropdown,
    WDashboardDownloadDropdown,
    WMapButton,
  },
  data() {
    return {
      DashboardConst,
    };
  },
  mixins: [Base],
  computed: {
    title() {
      return this.dashboardData && this.dashboardData.dashboardName;
    },
    disabled() {
      return isEmpty(this.dashboardData) || this.isDashboardLoading || this.isSlideshow;
    },
    isActive() {
      const activeWidgets = filter(this.widgetLayout, ['active', true]);

      return !isEmpty(activeWidgets);
    },
  },
  methods: {
    /**
     * 전체화면 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onFullScreenClick() {
      if (this.isCoordDashboard) {
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN);
      } else {
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.GRID_FULL_SCREEN);
      }
    },
    /**
     * 대시보드 편집 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onDashboardEditClick() {
      this.$store.commit('setDashboardViewMode', DashboardConst.VIEW_MODE.EDIT);
    },
    /**
     * 초기화 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onResetClick() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ACTIVE_CLEAR);

      this.$confirm(...msgUtil.getBasicConfirmData('초기화'))
        .then(() => {
          this.showLoading(true);
          setTimeout(() => {
            this.$store.commit('resetDashboardData');
            this.$nextTick(() => {
              this.showLoading(false);
            });
          }, 100);
        })
        .catch(() => {});
    },
    /**
     * 저장버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onSaveClick() {
      // 저장하기 전 좌표 대시보드에서 모든 위젯을 미선택 상태로 변경한다.
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ACTIVE_CLEAR);

      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.SAVE))
        .then(() => {
          this.showLoading(true);
          DashboardAPI.updateDashboardWidget(this.$store.getters.getDashboardData).then((response) => {
            this.showLoading(false);

            const result = response.data;
            const self = this;
            if (result.success) {
              // 대시보드 이름이 변경되었으면 트리에도 반영해야하기 때문에 트리를 리로드한다.
              if (this.$store.state.dashboard.orgDashboardData.dashboardName !== this.$store.state.dashboard.dashboardData.dashboardName) {
                self.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.TREE_LOAD);
              }
              // 저장 된 내용으로 대시보드를 로드한다.
              self.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_LOAD, self.currentDashboardId);
              this.$nextTick(() => {
                this.$message({
                  message: '저장하였습니다.',
                });
              });
              // this.$alert('저장하였습니다.', '정보', {
              //   confirmButtonText: '확인',
              //   callback: () => {
              //     this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_LOAD, this.currentDashboardId);
              //   },
              // });
            } else {
              this.$message('저장을 실패하였습니다.');
            }
          });
        })
        .catch(() => {});
    },
    /**
     * 취소 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onCancelClick() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ACTIVE_CLEAR);

      this.$confirm(...msgUtil.getCustomConfirmData('나가시겠습니까?'))
        .then(() => {
          this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_LOAD, this.currentDashboardId);
        })
        .catch(() => {});
    },
    /**
     * 슬라이드쇼 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onSlideshowClick() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.SLIDESHOW_SET);
    },
    onDashboardSettingClick() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_SET_ON_EDIT, this.dashboardData);
    },
    onResponsiveClick() {
      this.$store.commit('setResponsiveLayout', !this.isResponsive);
    },
  },
};
</script>

<style module>
.toolbar {
  background-color: #fff;
  justify-content: flex-end;
  overflow: hidden;
  display: flex;
}

.title {
  flex: 1;
  padding-right: 10px;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/DashboardToolbar.vue